import { ShopOutlined } from '@ant-design/icons';
import { styled } from '@stitches/configed';
import { AddStoreIcon, RouteContext } from '@you-go-vn/components';
import ArrowDown2Icon from '@you-go-vn/components/src/Common/Icons/ArrowDown2Icon';
import { Tooltip } from 'antd';
import { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../store';

const Title = styled('div', {
  marginLeft: 8,
  marginRight: 8,
  maxWidth: 220,
  fontSize: 16,
  whiteSpace: 'normal',
  variants: {
    ellipsis: {
      true: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        lineHeight: 1,
      },
    },
    noIcon: {
      true: {
        maxWidth: 'none',
        marginLeft: 0,
        marginRight: 0,
        lineHeight: '20px',
      },
    },
    font600: {
      true: {
        fontWeight: 600,
      },
    },
  },
});

const ButtonSelectorStyled = styled('div', {
  backgroundColor: '#FAFBFF1A',
  margin: '16px 0',
  padding: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 10,
  cursor: 'pointer',

  textOverflow: 'ellipsis',
  overflow: 'hidden',
});
const ButtonAddRestaurantStyled = styled('div', {
  backgroundColor: '$brand',
  color: 'white',
  margin: '16px 0',
  padding: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 10,
  cursor: 'pointer',
  svg: {
    fontSize: 20,
    marginRight: 8,
  },
});

export default function RestaurantSelectorMobile() {
  const location = useLocation();
  const navigate = useNavigate();
  const { menuCollapsed } = useContext(RouteContext);
  const { restaurants, currentRestaurant } = useAppSelector(
    (state) => state.restaurant,
  );

  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipAddVisible, setTooltipAddVisible] = useState(false);

  return (
    <>
      <Tooltip
        overlay="Thêm nhà hàng mới"
        placement="right"
        visible={tooltipAddVisible}
        onVisibleChange={(visible) => {
          if (visible && menuCollapsed) {
            setTooltipAddVisible(true);
          } else {
            setTooltipAddVisible(false);
          }
        }}
      >
        <ButtonAddRestaurantStyled
          key="add-restaurant"
          title="Thêm nhà hàng mới"
          onClick={() => {
            navigate('/restaurant-register');
          }}
        >
          <div style={{ marginLeft: 8 }}>
            <AddStoreIcon />
          </div>
          <div
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              lineHeight: 1, // requestment -> use with overflow
              fontWeight: 'bold',
            }}
          >
            Thêm nhà hàng mới
          </div>
        </ButtonAddRestaurantStyled>
      </Tooltip>

      {!restaurants || restaurants.length === 0 ? (
        <>
          <ButtonSelectorStyled>
            <ShopOutlined style={{ fontSize: 20 }} />
            <div>
              <b>Chưa có nhà hàng nào</b>
            </div>
          </ButtonSelectorStyled>
        </>
      ) : (
        <>
          <Tooltip
            overlay={currentRestaurant?.name}
            placement="right"
            visible={tooltipVisible}
            onVisibleChange={(visible) => {
              if (visible && menuCollapsed) {
                setTooltipVisible(true);
              } else {
                setTooltipVisible(false);
              }
            }}
          >
            <ButtonSelectorStyled
              onClick={() =>
                navigate('/restaurants?callback=' + location.pathname)
              }
            >
              <ShopOutlined style={{ fontSize: 20 }} />
              <Title
                ellipsis
                style={
                  menuCollapsed
                    ? {
                        display: 'none',
                      }
                    : {}
                }
              >
                {currentRestaurant?.name}
              </Title>
              <ArrowDown2Icon
                style={
                  menuCollapsed
                    ? {
                        display: 'none',
                      }
                    : {}
                }
              />
            </ButtonSelectorStyled>
          </Tooltip>
        </>
      )}
    </>
  );
}
